import { Box, Container } from "@mui/material";
import { Navigate, Outlet } from "react-router-dom";
import Topbar from "./Topbar";
import { useAppSelector } from "../hooks/store";

function MainContainer({ hideHeader = false }: { hideHeader?: boolean }) {
  const token = useAppSelector((state) => state.auth.token);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      {!hideHeader && <Topbar />}
      <Box
        component="main"
        className="main_content"
        sx={{
          marginLeft: "auto",
          width: "100%",
        }}
      >
        <Container className="sub-layout">
          <Outlet />
        </Container>
      </Box>
    </>
  );
}
export default MainContainer;
